import type { ReactNode } from 'react';

import { usePlayerStore } from '../store/playerStore';
import type { PlayerPlaybackRange } from '../types';

export interface PlayerControlsRenderProps {
  activeActorId: string | null;
  isPlaying: boolean;
  currentFrame: number;
  durationFrames: number;
  durationSeconds: number;
  playbackRange: PlayerPlaybackRange | null;
  play: () => void;
  pause: () => void;
  toggle: () => void;
  playOrPause: (playState?: boolean) => void;
  setFrame: (frame: number) => void;
  frameJump: (numFrames: number) => void;
  setPlaybackRange: (playbackRange: PlayerPlaybackRange | null) => void;
}

export interface PlayerControlsProps {
  playerId?: string;
  children: (props: PlayerControlsRenderProps) => ReactNode;
}

export default function PlayerControls({
  playerId,
  children,
}: PlayerControlsProps) {
  const store = usePlayerStore();
  const resolvedActorId = playerId ?? store.state.activeActorId;
  const { transport } = store.state;

  return children({
    activeActorId: resolvedActorId ?? null,
    isPlaying: transport.isPlaying,
    currentFrame: transport.currentFrame,
    durationFrames: transport.duration.frames,
    durationSeconds: transport.duration.seconds,
    playbackRange: transport.playbackRange,
    play: () => store.play(playerId),
    pause: () => store.pause(playerId),
    toggle: () => store.toggle(playerId),
    playOrPause: (playState) => store.playOrPause(playState, playerId),
    setFrame: (frame) => store.setFrame(frame, playerId),
    frameJump: (numFrames) => store.frameJump(numFrames, playerId),
    setPlaybackRange: (playbackRange) => store.setPlaybackRange(playbackRange),
  });
}
